<div class="card">
    <div class="card-body">
      <div class="d-flex mb-3">
        <h4 class="card-title">Message</h4>
      </div>
      
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)" enctype="multipart/form-data">
        <div class="modal-body pt-4">
          <div class="form-group">
              <label class="form-label">Message Title</label>
              <editor
                id="editor"
                formControlName="title"
                [init]="{ plugins: 'lists link image table code help wordcount' }"
                (onInit)="handleEvent($event)"
              ></editor>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['title'].errors?.['required'] && (f2['title'].dirty || f2['title'].touched)">
                  Please fill title.
              </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label d-block">Thumbnail</label>
                <input type="file" #fileUploader formControlName="thumbnail" accept="image/jpg,image/jpeg,image/png" (change)="onSelectFile($event)">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['thumbnail'].errors?.['required'] && (f2['thumbnail'].dirty || f2['thumbnail'].touched)">
                    Please select png, jpeg or jpg image.
                </div>
                <br *ngIf="imageurl"/>
                <br *ngIf="imageurl"/>
                <img [src]="imageurl" *ngIf="imageurl && imageurl!='undefined'" height="100">
                <br/>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
</div>